import { hasValue } from '@util-lib/hasValue'
import { FAQData, FAQTopicKey } from './faq.model'

export type FaqValidator = (data: FAQData) => string | null

const allTopicKeysExist: FaqValidator = (data: FAQData) => {
    const requiredKeys = data.topics.map((topic) => topic.topicKey)
    const missingKeys = Object.values(FAQTopicKey)
        .map((topicKey) => (requiredKeys.includes(topicKey) ? null : topicKey))
        .filter(hasValue)
    return missingKeys.length > 0
        ? `Missing Topic keys: ${missingKeys.join(',')}`
        : null
}

const allCategoryKeysAreUnique: FaqValidator = (data: FAQData) => {
    const categoryKeys = data.topics
        .flatMap((topic) => topic.categories)
        .map((category) => category.categoryKey)

    const duplicateCategoryKeys = [
        ...new Set(
            categoryKeys.filter(
                (item, index) => categoryKeys.indexOf(item) !== index
            )
        ),
    ]
    return duplicateCategoryKeys.length > 0
        ? `Duplicate category keys: ${duplicateCategoryKeys.join(',')}`
        : null
}

const allQuestionKeysAreUnique: FaqValidator = (data: FAQData) => {
    const questionKeys = data.topics
        .flatMap((topic) => topic.categories)
        .flatMap((categories) => categories.questions)
        .map((question) => question.questionKey)

    const duplicateQuestionKeys = [
        ...new Set(
            questionKeys.filter(
                (item, index) => questionKeys.indexOf(item) !== index
            )
        ),
    ]
    return duplicateQuestionKeys.length > 0
        ? `Duplicate question keys: ${duplicateQuestionKeys.join(',')}`
        : null
}

export const getAllFaqValidators: () => FaqValidator[] = () => [
    allTopicKeysExist,
    allCategoryKeysAreUnique,
    allQuestionKeysAreUnique,
]
